var map = {
	"./_default.json": 436,
	"./ancot.json": 437,
	"./bmarken.json": 438,
	"./cittaviva.json": 439,
	"./class.json": 440,
	"./coop.json": 441,
	"./crai.json": 442,
	"./csp.json": 443,
	"./doreca.json": 444,
	"./doro.json": 445,
	"./ekom.json": 446,
	"./enel.json": 447,
	"./fashionzclub.json": 448,
	"./gdsp.json": 449,
	"./goovi.json": 450,
	"./lcng.json": 451,
	"./lie.json": 452,
	"./mauto.json": 453,
	"./mysarca.json": 454,
	"./retex-bistrot.json": 455,
	"./retex.json": 456,
	"./self-service.json": 457,
	"./smarttouch.json": 458,
	"./smkt.json": 459,
	"./voghera.json": 460,
	"./wikimuseo.json": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;